import { BaseDto } from '@greco/util-dto';
import { AgreementType } from '../models';

export class UpdateCommunityAgreementDto extends BaseDto {
  title?: string;
  text?: string;
  agreementType?: AgreementType;
}
